import React from 'react';

import { type DragEndEvent } from '@dnd-kit/core';

import { ProductListCard } from '@/app/[locale]/shop/[username]/(shop)/components/ProductList/ProductListCard';
import styles from '@/app/[locale]/shop/[username]/(shop)/components/ProductList/styles.module.css';
import { SortableItemWrapper } from '@/components/SortableItemWrapper';
import { SortableItemsContainer } from '@/components/SortableItemsContainer';
import { type ShopListProduct } from '@/modules/shop/types';

type Props = {
  products: ShopListProduct[];
  handleDragEnd: (event: DragEndEvent) => void;
};

export function RearrangeProductList({ products, handleDragEnd }: Props) {
  return (
    <SortableItemsContainer
      onDragEnd={handleDragEnd}
      items={products.map((product) => product.id)}
    >
      {products.map((product) => (
        <li key={product.id} className={styles.listItem}>
          <SortableItemWrapper
            id={product.id}
            className={styles.animatedWrapper}
          >
            <ProductListCard isRearrangeModeActive product={product} />
          </SortableItemWrapper>
        </li>
      ))}
    </SortableItemsContainer>
  );
}
